<script>
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";

export default {
  locales: {
    pt: {
      'Binary': 'Binário',
      'Left': 'Esquerdo',
      'Right': 'Direito',
      'Smaller': 'Menor',
      'Spillover Side': 'Lado de Derramamento',
      'Choose a side': 'Escolha um lado',
      'Left Side': 'Lado Esquerdo',
      'Right Side': 'Lado Direito',
      'Smaller Side': 'Lado Menor',
      'Save': 'Salvar',
      'The spillover side has been successfully changed!': 'O lado de derramamento foi alterado com sucesso!',
    },
    es: {
      'Binary': 'Binario',
      'Left': 'Izquierdo',
      'Right': 'Derecho',
      'Smaller': 'Menor',
      'Spillover Side': 'Lado de Desbordamiento',
      'Choose a side': 'Elige un lado',
      'Left Side': 'Lado Izquierdo',
      'Right Side': 'Lado Derecho',
      'Smaller Side': 'Lado Menor',
      'Save': 'Guardar',
      'The spillover side has been successfully changed!': '¡El lado de desbordamiento ha sido cambiado con éxito!',
    }
  },
  components: {
    Stat
  },
  data() {
    return {
      binaryClock: {
        timer: null,
        percent: 0,
        countdown: { hours: 0, minutes: 0, seconds: 0 },
      },

      binary: {
        modal: false,
        loading: false,
        side: "",

        status: "inactive",
        points: {
          left: "-",
          right: "-",
        },
        percent: "-%",
        perpoint: "R$ -,--",
        bonus: "R$ -,--",
      },
    };
  },
  methods: {
    getBinaryResume() {
      api
        .get('network/binary')
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.status = response.data.resume.status;
            this.binary.points.left = this.$options.filters.points(response.data.resume.points.left);
            this.binary.points.right = this.$options.filters.points(response.data.resume.points.right);
            this.binary.percent = response.data.resume.percent;
            this.binary.perpoint = this.$options.filters.currency(response.data.resume.perpoint);
            this.binary.bonus = this.$options.filters.currency(response.data.resume.bonus);
          }
        })
    },
    getBinarySide() {
      api
        .get('network/binary/side')
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.side = response.data.side
          }
        })
    },
    changeBinarySide() {
      this.binary.modal = false;
      this.binary.modal = true;
      this.binary.loading = false;
    },
    // Contador até meia-noite no horário de Miami (America/New_York)
    initBinaryMidnightClock() {
      if (this.binaryClock.timer) {
        clearInterval(this.binaryClock.timer)
        this.binaryClock.timer = null
      }
      const tick = () => {
        const miamiFormatter = new Intl.DateTimeFormat('en-US', {
          timeZone: 'America/New_York',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit',
          hour12: false,
        })
        const parts = miamiFormatter.formatToParts(new Date())
        const get = (type) => parseInt(parts.find(p => p.type === type).value, 10)
        const hour = get('hour'), minute = get('minute'), second = get('second')

        // Segundos decorridos desde meia-noite em Miami
        const elapsedSeconds = hour * 3600 + minute * 60 + second
        const daySeconds = 86400
        const remainingSeconds = daySeconds - elapsedSeconds

        this.binaryClock.percent = Math.min(100, (elapsedSeconds / daySeconds) * 100)

        const hours = Math.floor(remainingSeconds / 3600)
        const minutes = Math.floor((remainingSeconds % 3600) / 60)
        const seconds = remainingSeconds % 60
        this.binaryClock.countdown = { hours, minutes, seconds }
      }
      tick()
      this.binaryClock.timer = setInterval(tick, 1000)
    },
    saveBinarySide() {
      this.binary.loading = true;

      api
        .post('network/binary/side', {
          side: this.binary.side
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.binary.modal = false;
            this.binary.loading = false;
            this.$toast.success(this.t('The spillover side has been successfully changed!'))
            this.getBinarySide();
          }
        })
        .finally(() => {
          this.binary.loading = false;
        })
    }
  },
  mounted() {
    this.getBinaryResume()
    this.getBinarySide()
    this.initBinaryMidnightClock()
  },
  beforeDestroy() {
    if (this.binaryClock.timer) {
      clearInterval(this.binaryClock.timer)
      this.binaryClock.timer = null
    }
  },
};
</script>

<template>
  <div>
    <fieldset class="binary pb-0">
      <legend>
        {{ t('Binary') }}
      </legend>
      <div class="card">
        <div class="card-body d-flex flex-column align-items-center text-center">
          <div class="binary-midnight-progress w-100 mb-3">
            <div class="binary-midnight-progress__track">
              <div class="binary-midnight-progress__fill" :style="{ width: binaryClock.percent + '%' }"></div>
            </div>
          </div>
          <div class="d-flex justify-content-center binary-midnight-countdown">
            <div class="binary-midnight-box">
              <span class="binary-midnight-num">{{ String(binaryClock.countdown.hours).padStart(2, '0') }}</span>
              <span class="binary-midnight-label">H</span>
            </div>
            <div class="binary-midnight-box">
              <span class="binary-midnight-num">{{ String(binaryClock.countdown.minutes).padStart(2, '0') }}</span>
              <span class="binary-midnight-label">M</span>
            </div>
            <div class="binary-midnight-box">
              <span class="binary-midnight-num">{{ String(binaryClock.countdown.seconds).padStart(2, '0') }}</span>
              <span class="binary-midnight-label">S</span>
            </div>
          </div>
        </div>
      </div>

      <div class="binary-config">
        <button v-on:click="changeBinarySide()">
          <div class="d-flex align-items-center">
            <div class="side">
              <template v-if="binary.side == 'l'">{{ t('Left') }}</template>
              <template v-else-if="binary.side == 'r'">{{ t('Right') }}</template>
              <template v-else-if="binary.side == 'm'">{{ t('Smaller') }}</template>
              <template v-else>...</template>
            </div>
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
                <path d="M12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.084 0 2 .916 2 2s-.916 2-2 2-2-.916-2-2 .916-2 2-2z"></path>
                <path
                  d="m2.845 16.136 1 1.73c.531.917 1.809 1.261 2.73.73l.529-.306A8.1 8.1 0 0 0 9 19.402V20c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-.598a8.132 8.132 0 0 0 1.896-1.111l.529.306c.923.53 2.198.188 2.731-.731l.999-1.729a2.001 2.001 0 0 0-.731-2.732l-.505-.292a7.718 7.718 0 0 0 0-2.224l.505-.292a2.002 2.002 0 0 0 .731-2.732l-.999-1.729c-.531-.92-1.808-1.265-2.731-.732l-.529.306A8.1 8.1 0 0 0 15 4.598V4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v.598a8.132 8.132 0 0 0-1.896 1.111l-.529-.306c-.924-.531-2.2-.187-2.731.732l-.999 1.729a2.001 2.001 0 0 0 .731 2.732l.505.292a7.683 7.683 0 0 0 0 2.223l-.505.292a2.003 2.003 0 0 0-.731 2.733zm3.326-2.758A5.703 5.703 0 0 1 6 12c0-.462.058-.926.17-1.378a.999.999 0 0 0-.47-1.108l-1.123-.65.998-1.729 1.145.662a.997.997 0 0 0 1.188-.142 6.071 6.071 0 0 1 2.384-1.399A1 1 0 0 0 11 5.3V4h2v1.3a1 1 0 0 0 .708.956 6.083 6.083 0 0 1 2.384 1.399.999.999 0 0 0 1.188.142l1.144-.661 1 1.729-1.124.649a1 1 0 0 0-.47 1.108c.112.452.17.916.17 1.378 0 .461-.058.925-.171 1.378a1 1 0 0 0 .471 1.108l1.123.649-.998 1.729-1.145-.661a.996.996 0 0 0-1.188.142 6.071 6.071 0 0 1-2.384 1.399A1 1 0 0 0 13 18.7l.002 1.3H11v-1.3a1 1 0 0 0-.708-.956 6.083 6.083 0 0 1-2.384-1.399.992.992 0 0 0-1.188-.141l-1.144.662-1-1.729 1.124-.651a1 1 0 0 0 .471-1.108z">
                </path>
              </svg>
            </div>
          </div>
        </button>
      </div>

      <div class="row">
        <div class="col-12 col-md-4 col-lg-2">
          <Stat type="square" icon="bx-trophy" title="Status" :value="binary.status == 'active' ? 'qualified' : 'not_qualified'" />
        </div>

        <div class="col-6 col-md-4 col-lg-2">
          <Stat type="square" icon="bx-subdirectory-left" title="Left Side" :value="binary.points.left" />
        </div>

        <div class="col-6 col-md-4 col-lg-2">
          <Stat type="square" icon="bx-subdirectory-right" title="Right Side" :value="binary.points.right" />
        </div>

        <div class="col-12 col-md-4 col-lg-2">
          <Stat type="square" icon="bx-calculator" title="COEFFICIENT" :value="'1 PV = ' + binary.perpoint" />
        </div>

        <div class="col-6 col-md-4 col-lg-2">
          <Stat type="square" icon="bx-calculator" title="Percent" :value="binary.percent" />
        </div>

        <div class="col-6 col-md-4 col-lg-2">
          <Stat type="square" icon="bx-dollar" title="Bonus" :value="binary.bonus" />
        </div>
      </div>
    </fieldset>

    <b-modal v-model="binary.modal" :title="t('Spillover Side')" modal-class="modal-right" hide-footer>
      <b-form @submit.prevent="saveBinarySide()">
        <b-form-group :label="t('Choose a side')" label-for="binary.side">
          <select v-model="binary.side" class="custom-select mb-2">
            <option value="l">{{ t('Left Side') }}</option>
            <option value="r">{{ t('Right Side') }}</option>
            <option value="m">{{ t('Smaller Side') }}</option>
          </select>
        </b-form-group>
        <b-button class="mb-0" :disabled="this.binary.loading" type="submit" variant="default" size="lg">
          {{ t('Save') }}
          <b-spinner v-if="binary.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
        </b-button>
      </b-form>
    </b-modal>
  </div>
</template>
